import React from "react";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import {ERROR, SUCCESS} from "../../shipments/constants";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import {
    ADD_PORT,
    BACK, FTL_NOA_PORTS_TABLE_HEADERS,
    FTL_PAGES,
    FULL_TRUCKLOAD_SETTINGS,
    REMOVE_PORT,
    SAVE
} from "../constants";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import SaveIcon from "@material-ui/icons/Save";
import {IconButton, Tab, Table, TableCell, TableRow, Tabs, TextField, Tooltip} from "@material-ui/core";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import FileUpload from "../../global/FileUpload";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import withShipment from "../../../withShipment";
import {
    fullTruckloadPortsSelector,
    savePoeResponseMessageSelector,

} from "../../../redux/selectors/fullTruckload";
import {
    listFullTruckloadPOEs, saveFullTruckloadPOEs,
} from "../../../redux/actions/fullTruckload";

class FullTruckloadPOEs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ports: [],
            settingsChanged: false,
            feedbackBarOpen: false,
            errorMessage:"",
            errorFeedbackBarOpen: false,
        };
    }

    componentDidMount() {
        this.props.listFullTruckloadPOEs()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.ports !== this.props.ports) {
            this.setState({
                ports: this.props.ports,
            })
        }
        if (prevProps.responseMessage !== this.props.responseMessage && this.props.responseMessage!=="") {
            this.setState({
                feedbackBarOpen: true
            })
        }
    }

    addPort = () => {
        let tempPortList = this.state.ports;
        tempPortList.push({ city: "", state: "", country: "", portOfEntry: ""});
        this.setState({
            ports: tempPortList
        });
    }

    deletePort = (index) => {
        let newPorts = this.state.ports
        newPorts.splice(index, 1)
        this.setState({
            ports: newPorts,
            deletingRowIndex: -1,
            settingsChanged: true
        })
    };

    handleChanges = (e, index) => {
        let tempPorts = this.state.ports
        tempPorts[index][e.target.name] = e.target.value
        this.setState({
            ports: tempPorts
        });
    }

    savePorts() {
        this.props.saveFullTruckloadPOEs(this.state.ports)
    }

    render() {
        return (
            <React.Fragment>
                <ErrorFeedbackBar/>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    severity={SUCCESS}
                    message={this.props.responseMessage}
                    handleClose={this.closeFeedbackBar}
                />
                <FeedbackBar
                    open={this.state.errorFeedbackBarOpen}
                    severity={ERROR}
                    message={this.state.errorMessage}
                    handleClose={this.closeErrorFeedbackBar}
                />
                <TopToolbar
                    pageName={FULL_TRUCKLOAD_SETTINGS}
                    menuItems={[
                        { title: BACK, icon: <KeyboardBackspaceIcon />, onClick: () => { this.props.setCurrentPage(FTL_PAGES.TABLE); } },
                        { title: SAVE, icon: <SaveIcon/>, onClick: () => {this.savePorts()}},
                    ]}
                />

                <Tabs
                    value={this.props.selectedTab}
                    onChange={(event, value) => this.props.handleTabChange(value)}
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label={FTL_PAGES.SETUP} />
                    <Tab label={FTL_PAGES.CUSTOMS_BROKERS} />
                    <Tab label={FTL_PAGES.SIGNATURES} />
                    <Tab label= {FTL_PAGES.NOA_PORTS}/>
                </Tabs>

                <div style={{ margin: "25px" }}>
                    <Table>
                        <TableRow>
                            {FTL_NOA_PORTS_TABLE_HEADERS.map((headCell) => (
                                <TableCell key={headCell.id} style={{ textAlign: "center", fontWeight: "bold", width: headCell.width }}>
                                    {headCell.label}
                                </TableCell>
                            ))}
                        </TableRow>
                        {this.state.ports.map((port, index) => (
                            <TableRow key={index}>
                                <TableCell style={{width:"10%"}}>
                                    <Tooltip title={REMOVE_PORT}>
                                        <IconButton onClick={() => this.deletePort(index)}>
                                            <RemoveCircleIcon fontSize="small" color="error" />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                                <TableCell style={{width:"22.5%"}}>
                                    <TextField
                                        style={{width:"100%"}}
                                        className='text-field'
                                        variant="outlined"
                                        name="portOfEntry"
                                        value={port.portOfEntry}
                                        onChange={(e) => this.handleChanges(e, index)}
                                        InputLabelProps={{ shrink: true }}
                                        required
                                    />
                                </TableCell>
                                <TableCell style={{width:"22.5%"}}>
                                    <TextField
                                        style={{width:"100%"}}
                                        className='text-field'
                                        variant="outlined"
                                        name="city"
                                        value={port.city}
                                        onChange={(e) => this.handleChanges(e, index)}
                                        InputLabelProps={{ shrink: true }}
                                        required
                                    />
                                </TableCell>
                                <TableCell style={{width:"22.5%"}}>
                                    <TextField
                                        style={{width:"100%"}}
                                        className='text-field'
                                        variant="outlined"
                                        name="state"
                                        value={port.state}
                                        onChange={(e) => this.handleChanges(e, index)}
                                        InputLabelProps={{ shrink: true }}
                                        required
                                    />
                                </TableCell>
                                <TableCell style={{width:"22.5%"}}>
                                    <TextField
                                        style={{width:"100%"}}
                                        className='text-field'
                                        variant="outlined"
                                        name="country"
                                        value={port.country}
                                        onChange={(e) => this.handleChanges(e, index)}
                                        InputLabelProps={{ shrink: true }}
                                        required
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell>
                                <Tooltip title={ADD_PORT}>
                                    <IconButton onClick={this.addPort}>
                                        <AddCircleIcon fontSize="small" color="secondary" />
                                    </IconButton>
                                </Tooltip>
                            </TableCell>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                            <TableCell/>
                        </TableRow>
                    </Table>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    ports: fullTruckloadPortsSelector(state),
    responseMessage: savePoeResponseMessageSelector(state)
});

const actionCreators = {
    saveFullTruckloadPOEs,
    listFullTruckloadPOEs,
};

export default withShipment({
    mapStateToProps,
    actionCreators,
}, FullTruckloadPOEs);